// product page description read more and read less script
document.addEventListener('DOMContentLoaded', () => {
  const d = document.querySelector('#productDescription');
  if (!d || d.scrollHeight < 250) return;

  d.classList.add('is-collapsed');

  d.insertAdjacentHTML(
    'afterend',
    '<button class="desc-toggle" type="button"><span>+</span> Read More</button>'
  );

  document.querySelector('.desc-toggle').onclick = function () {
    const open = d.classList.toggle('is-open');
    this.innerHTML = open
      ? '<span>−</span> Read Less'
      : '<span>+</span> Read More';
  };
});

//  product cards buttons displayed the add to cart when variation

document.addEventListener('change', (e) => {
  const select = e.target.closest('.ca-select');
  if (!select || !select.value) return;

  const button = select.closest('.ca-form')?.querySelector('.ca-button');
  if (button) button.style.display = '';
});
